module.exports = __webpack_public_path__ + "static/media/envelope.829813e0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/envelope.svg
 ** module id = 2072
 ** module chunks = 44
 **/